import { createContext, useContext } from 'react';
const notImplementedFn = __args => {
  console.warn('An unimplemented function from TableContext was called.');
};
export const TableContext = /*#__PURE__*/createContext({
  onStartTaskQueue: notImplementedFn,
  onRefreshSearch: notImplementedFn,
  onDelayedRefreshSearch: notImplementedFn
});
export function useTableContext() {
  return useContext(TableContext);
}